var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"map",staticClass:"google-map"},[_c('info-box-map',{ref:"markerPopup",attrs:{"dates":_vm.dates,"accommodationId":_vm.accommodationSelected ? _vm.accommodationSelected.AccommodationId : null}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }